import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Advertisers = [
    {
      id: '01',
      image: '/celtic-woman-2022/ads/jerry-seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Jerry Seiner Cadillac',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/celtic-woman-2022/ads/springville.jpg',
      link: 'http://www.smofa.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Springville Museum of Art',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/celtic-woman-2022/ads/moab.jpg',
      link: 'https://www.discovermoab.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Discover Moab',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/celtic-woman-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Festival Opera & Musical Theatre',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/celtic-woman-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Werners European',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/celtic-woman-2022/ads/rubys-inn.jpg',
      link: 'https://www.rubysinn.com/millsdec22',
      alt: 'Rubys Inn',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/celtic-woman-2022/ads/cultural-enterprise.jpg',
      link: 'https://www.williamcall.net/fantasy/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/celtic-woman-2022/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/celtic-woman-2022/ads/Hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/celtic-woman-2022/ads/minky.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/celtic-woman-2022/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/celtic-woman-2022/ads/utah-food-bank.jpg',
      link: 'https://www.utahfoodbank.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Food Bank',
      class: 'webFormat',
    },
    {
      id: '13',
      image: '/celtic-woman-2022/ads/u-first.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      id: '14',
      image: '/celtic-woman-2022/ads/bosso.jpg',
      link: 'https://www.bozzo.biz/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Bosso Smart Lighting',
      class: 'webFormat',
    },
  ];

  Advertisers.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Advertisers.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
